import { render, staticRenderFns } from "./AjusteListagem.vue?vue&type=template&id=8f4ca1a8&"
import script from "./AjusteListagem.vue?vue&type=script&lang=js&"
export * from "./AjusteListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports